module.exports = __webpack_public_path__ + "img/icon_no_data.49b152f9.svg";